import FormGroup from "shared/form/fields/formGroup";
import DynamicFieldConfigType from "../../types/DynamicFieldConfigType";

export default function SectionSeparator(props: DynamicFieldConfigType) {
  return (
    <FormGroup fullWidth={true} indented={props.schemaObj.indented}>
      <hr />
    </FormGroup>
  );
}
